<div class="page-content d-flex align-items-center justify-content-center">
  <div class="card col-11 col-md-6 col-lg-4 shadow rounded p-4 border-0">
    <div class="card-body p-0">
      <h5 class="card-title text-center mb-4">{{ 'sign_in' | transloco }}</h5>
      @if (whoSignIn === UserTypeEnum.patient) {
        <div class="mt-2 mb-2">
          <span class="text-center">{{ selectedProgramTitle }}</span>
          @if (programsInBasket && programsInBasket > 1) {
            <span>{{ 'and_others' | transloco }}</span>
          }
        </div>
      }
      @if (myForm) {
        <form [formGroup]="myForm" (ngSubmit)="onSubmit()" class="d-flex flex-column gap-3">
          @if (whoSignIn === UserTypeEnum.patient) {
            <app-input-phone-email formControlName="contact" />
          } @else {
            <div class="input-group">
              <span class="input-group-text">
                <i class="bi bi-envelope"></i>
              </span>
              <div class="form-floating">
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  formControlName="email"
                  placeholder="{{ 'email' | transloco }}"
                  [class.is-invalid]="myForm.controls['email'].invalid && myForm.controls['email'].touched"
                />
                <label [appRequiredAsterisk]="'email'" [formGroup]="myForm" for="email">
                  {{ 'email' | transloco }}
                </label>
              </div>
              @if (myForm.controls['email'].touched && myForm.controls['email'].hasError('required')) {
                <div class="invalid-feedback">
                  {{ 'error.fill_field' | transloco }}
                </div>
              } @else if (myForm.controls['email'].touched && myForm.controls['email'].hasError('email')) {
                <div class="invalid-feedback">
                  {{ 'error.email' | transloco }}
                </div>
              }
            </div>
          }

          <div class="input-group">
            @if (whoSignIn === UserTypeEnum.staff) {
              <span class="input-group-text">
                <i class="bi bi-person"></i>
              </span>
            }
            <div class="form-floating">
              <input
                [type]="passwordChecked ? 'text' : 'password'"
                class="form-control"
                id="password"
                formControlName="password"
                placeholder="{{ 'password' | transloco }}"
                [class.is-invalid]="myForm.controls['password'].invalid && myForm.controls['password'].touched"
              />
              <label for="password" [appRequiredAsterisk]="'password'" [formGroup]="myForm">{{
                'password' | transloco
              }}</label>
            </div>
            <span class="input-group-text">
              <label
                class="btn btn-outline-secondary"
                for="togglePassword"
                (click)="passwordChecked = !passwordChecked"
              >
                <i class="bi" id="eyeIcon" [class]="passwordChecked ? 'bi-eye' : 'bi-eye-slash'"></i>
              </label>
            </span>
            @if (myForm.controls['password'].touched && myForm.controls['password'].hasError('required')) {
              <div class="invalid-feedback">
                {{ 'error.fill_field' | transloco }}
              </div>
            }
          </div>
          <button type="submit" class="btn btn-primary w-100" [disabled]="!myForm.valid || isLoading">
            @if (isLoading) {
              <span class="spinner-border spinner-border-sm"></span>
            } @else {
              <span>{{ 'sign_in' | transloco }}</span>
            }
          </button>

          @if (whoSignIn === UserTypeEnum.patient) {
            <div class="d-flex align-items-center">
              <hr class="flex-grow-1" />
              <span class="mx-2">OR</span>
              <hr class="flex-grow-1" />
            </div>
            <sign-in-google
              [whoSignIn]="whoSignIn"
              (googleCredentials)="googleCredentials.emit($event)"
            ></sign-in-google>
            <div class="d-flex justify-content-center gap-2">
              <span>
                {{ 'register_account' | transloco }}
              </span>
              <a [routerLink]="['/sign-up']" routerLinkActive="router-link-active" class="link-primary">{{
                'register' | transloco
              }}</a>
            </div>

            <div class="d-flex justify-content-center gap-2">
              <span>{{ 'forgot_password' | transloco }}</span>
              <a [routerLink]="['/restore']" routerLinkActive="router-link-active" class="link-primary">{{
                'restore' | transloco
              }}</a>
            </div>
          }
        </form>
      }
    </div>
  </div>
</div>
